package com.kinoshazam.uiKit.components.selectableText

data class SelectableTextState(
    val isSelected: Boolean,
    val title: String,
)
